import { useQuery } from 'react-query';
import { CompetitionEventAPI } from 'api/admin/competitionEvent';
import { COMPETITION_EVENTS, NO_RING } from 'helpers/constants';

export default function useCompetitionEventsWithoutRing(competitionId) {
  return useQuery([COMPETITION_EVENTS, competitionId, NO_RING], () =>
    CompetitionEventAPI.getAllWithoutRing(competitionId)
  );
}
